import { render, staticRenderFns } from "./fieldRecord.vue?vue&type=template&id=8f6dce5c&"
import script from "./fieldRecord.vue?vue&type=script&lang=js&"
export * from "./fieldRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports